/*
  Impulse t5932: the usage counter for the Help me choose finder.
  One function, window.impFinderTrack(name, detail), sends a "gear_finder_<name>" event to whatever the storefront already has:
    Microsoft Clarity  window.clarity('event', ...) and ('set', ...)   (the dashboard counts events; the tags filter sessions)
    Shopify            Shopify.analytics.publish(...)                   (a customer-events pixel can subscribe; harmless if none does)
    Google             gtag('event', ...) or a dataLayer push           (only when the page has one)
  Every call is guarded, so nothing breaks when a service is absent, blocked or late. Each event is also kept in
  window.impFinderEvents ({event, detail, at}) so a test or a person can read what was sent from the console.
  Elements with data-imp-track="<name>" (the home chip and card) are counted when clicked.
  Nothing personal is sent: only the name of the step, the category (camera, lens, light, audio, support, drone, bags, film, acc, unsure)
  and the answer values (for example result "Mirrorless", path "sony-e/wide/mid").
*/
(function () {
  'use strict';
  if (window.impFinderTrack) return;

  const PREFIX = 'gear_finder_';
  const log = (window.impFinderEvents = window.impFinderEvents || []);

  // Clarity's tag may load after the page's own script; a call made too early waits for it, for about ten seconds.
  const waiting = [];
  let timer = 0;
  const flushClarity = () => {
    if (typeof window.clarity !== 'function') return false;
    while (waiting.length) {
      try { window.clarity.apply(window, waiting.shift()); } catch (x) { /* a failing tag must never reach the page */ }
    }
    return true;
  };
  const clarity = (args) => {
    waiting.push(args);
    if (flushClarity() || timer) return;
    let tries = 0;
    timer = setInterval(() => {
      tries++;
      if (flushClarity() || tries >= 20) { clearInterval(timer); timer = 0; waiting.length = 0; }
    }, 500);
  };

  const track = (name, detail) => {
    const event = PREFIX + name;
    const data = {};
    Object.keys(detail || {}).forEach((k) => { if (detail[k] != null && detail[k] !== '') data[k] = String(detail[k]).slice(0, 80); });
    log.push({ event: event, detail: data, at: Date.now() });

    // Clarity: the event is counted in its dashboard; the tags (gear_finder_stage, gear_finder_category, gear_finder_result) filter sessions and recordings.
    clarity(['event', event]);
    clarity(['set', 'gear_finder_stage', name]);
    if (data.category) clarity(['set', 'gear_finder_category', data.category]);
    if (data.result) clarity(['set', 'gear_finder_result', data.result]);

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(event, data);
    } catch (x) { /* publishing is optional */ }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', event, data);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: event }, data));
    } catch (x) { /* so is Google */ }
  };
  window.impFinderTrack = track;

  // The home chip and card: one listener for anything marked data-imp-track. Counted on any click, a new-tab click too.
  document.addEventListener('click', (e) => {
    const t = e.target && e.target.closest ? e.target.closest('[data-imp-track]') : null;
    if (t) track(t.getAttribute('data-imp-track'), { from: 'home' });
  }, true);
}());
